import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from './styles';
import { Alias } from './types';
import AliasesDataGrid from './AliasesDataGrid';

type AliasesProps = {
  classes: Record<string, string>;
  aliases?: Alias[] | null;
};

const Aliases = ({ classes, aliases }: AliasesProps) => (
  <AliasesDataGrid classes={classes} aliases={aliases ?? []} />
);

export default withStyles(styles)(Aliases);
